// Build the reload-safe entry URL for the national flow. Redux carries the
// selected suggestion during normal navigation, but it is browser-memory only;
// the query parameter lets NationalIntakePage recover the complete address
// after a refresh or a copied link.
import { formatAddress } from "../utils";

export const nationalIntakeAddress = (suggestion = {}) => {
  const formatted = String(suggestion.formatted_address || "").trim();
  if (formatted) return formatted;

  const street = String(suggestion.canonical_address || "").trim();
  const city = String(suggestion.city || "").trim();
  const state = String(suggestion.state || "").trim();
  const zip = String(suggestion.zip_code || "").trim();
  const stateAndZip = [state, zip].filter(Boolean).join(" ");
  const locality = [city, stateAndZip].filter(Boolean).join(", ");

  return [street, locality].filter(Boolean).join(", ");
};

// The legacy formatter is part of the covered Texas flow's visible contract.
// External suggestions need the state as well, because the same city and street
// can exist in multiple states. Keep that distinction in one place for both
// autocomplete surfaces.
export const formatSuggestionAddress = (suggestion = {}) =>
  suggestion.covered === false
    ? nationalIntakeAddress(suggestion)
    : formatAddress(suggestion);

export const nationalIntakeEntryUrl = (suggestion) => {
  const address = nationalIntakeAddress(suggestion);
  return address
    ? `/national-intake?address=${encodeURIComponent(address)}`
    : "/national-intake";
};
